import { Calendar, Phone, ArrowUpRight } from "lucide-react";
import { business } from "../data/business";
import { useBusinessPhone } from "../hooks/useBusinessPhone";
import { fireToast } from "./Toast";

/**
 * Pre-footer conversion block — addresses the "where do I go next?" gap
 * on long pages. Two paths: external Book (TheFlyBook) and tel: call.
 * Honest copy — no fabricated discounts, urgency, or scarcity. The
 * eyebrow uses the same verified town as elsewhere ("Benton, TN").
 */
export function ClosingCta() {
  const { phone, phoneRaw } = useBusinessPhone();

  return (
    <section className="closing-cta" aria-labelledby="closing-cta-heading">
      <div className="closing-cta-inner">
        <span className="eye eye-inverse closing-cta-eyebrow">
          READY WHEN YOU ARE · BENTON, TN
        </span>
        <h2 id="closing-cta-heading" className="h2 closing-cta-headline">
          Ready to paddle the Ocoee?
        </h2>
        <p className="closing-cta-lead">
          Book online, or pick up the phone — either way, we'll get you on the
          river by the next release day.<sup aria-hidden="true">*</sup>
        </p>
        <p className="closing-cta-fineprint">* Subject to availability.</p>
        <div className="closing-cta-ctas">
          <a
            href={business.bookingBase}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-gold closing-cta-primary"
            onClick={() => fireToast("Opening booking page…")}
          >
            <Calendar size={16} aria-hidden="true" />
            Book Now
            <ArrowUpRight size={14} aria-hidden="true" />
            <span className="sr-only">Opens in a new tab</span>
          </a>
          <a
            href={`tel:${phoneRaw}`}
            className="btn btn-ghost closing-cta-secondary"
          >
            <Phone size={16} aria-hidden="true" />
            Call {phone}
          </a>
        </div>
      </div>
    </section>
  );
}
